import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-support-contact-dialog',
  templateUrl: './support-contact-dialog.component.html',
  styleUrls: ['./support-contact-dialog.component.scss']
})
export class SupportContactDialogComponent {

  constructor(
    private readonly dialogRef: MatDialogRef<SupportContactDialogComponent>,
    private readonly router: Router
  ) {}

  goToTutorials(): void {
    this.dialogRef.close();
    this.router.navigate(['/tutorials']);
  }

  goToFaq(): void {
    this.dialogRef.close();
    window.open('/zendesk-sso?return_to=' + encodeURIComponent('https://support.mypacs.vet/hc/fr'), '_blank');
  }
}
